/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/**
 * Formats a string by replacing placeholders with provided arguments.
 * @param str The string to format.
 * @param args The arguments to replace placeholders with.
 * @returns The formatted string.
 */
export function formatString(str: string, ...args: any[]): string {
    return str.replace(/{(\d+)}/g, (match, index) => {
        return typeof args[index] !== 'undefined' ? args[index] : match;
    });
}
